import useDialog from "@/hooks/useDialog"
import MallIcon from "@/pages/DDM/components/MallIcon"
import useDialogStore from "@/store/useDialogStore"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton, Typography } from "@mui/material"
import { memo, useCallback } from "react"
import { createPortal } from 'react-dom'

export default function DialogComponent() {
    const dialogRoot = document.getElementById('rootDialog') as HTMLElement
    const { revealed, description, type, message = '' } = useDialogStore()
    const { onInteractionEnd } = useDialog()
    const handleConfirmClick = useCallback(() => {
        onInteractionEnd(true)
    }, [type, onInteractionEnd])
    const handleCancelClick = useCallback(() => {
        onInteractionEnd(false)
    }, [type, onInteractionEnd])
    return (
        // 9 999 999
        // 11 000 000
        <Dialog open={revealed} maxWidth={'xs'} sx={{ zIndex: 11000000 }}>
            <IconButton onClick={handleCancelClick} sx={{ position: 'absolute', right: '1%', top: '1%' }}>
                <MallIcon iconName="del" />
            </IconButton>
            <DialogContent>
                <DialogContentText marginTop={'20px'} textAlign='center' sx={{ whiteSpace: 'pre-wrap' }}>
                    {description && <b>{description}</b>}
                </DialogContentText>
                <DialogContentText marginTop={'20px'} textAlign='center' sx={{ whiteSpace: 'pre-wrap' }}>
                    {message && <Typography variant="h5">{message}</Typography>}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {type === 'alert' && (
                    <>
                        <Button
                            variant='contained'
                            onClick={handleConfirmClick}
                        >
                            확인
                        </Button>
                    </>
                )}
                {type === 'confirm' && (
                    <>
                        <Button variant='outlined' onClick={handleCancelClick}>취소</Button>
                        <Button
                            variant='contained'
                            onClick={handleConfirmClick}
                        >
                            확인
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}